export const IS_DEV = process.env.NODE_ENV === 'development';

export const onlineHubHost = IS_DEV ? 'https://hub.dev.carlipa.io' : 'https://hub.carlipa.io';
